import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import { Dispatch, GetState } from 'model/State';
import { fetchDetails } from '../accounts';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  const { accountId } = getState().location.payload;
  dispatch(fetchDetails(accountId));
};
